import React , { useState , useEffect } from 'react'
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils'
import AllCompanies from './allCompanies';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import {
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";

function AllCompaniesTab(props: any) {
    
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3) 
  const [selected, setSelected] = useState<number>(0)
 
  useEffect(() => { 

    if(props.companyData){
      const hirer = props.companyData.filter((item: any) => {
        return(item.companyType === 1)
      })
      const provider = props.companyData.filter((item: any) => {
        return(item.companyType === 2)
      })
    }
  }, [props.companyData])

  const pageChange = (data: any) => {
    
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }

  const pageSize = (pageSize: any, pageNumber: number) => {
    
    props.pageSize(pageSize, pageNumber);
    
  }

  return (
    <section className="tableStyle">
       <TabStrip selected={selected} onSelect={handleSelect}>
          {props.type !== 'blacklisted' && <Tab title={'Hirer Companies'} >
            <AllCompanies 
            setSort={props.setSort} applySort={props.applySort} companyData={props.hirerComapnies} approveOrRejectCustomer={props.approveOrRejectCustomer} total={props.hirerTotal} handlePageChange={props.handlePageChange} submitSourcedBy={props.submitSourcedBy} allocatedToList={props.allocatedToList} SubmitCustomerAllocation={props.SubmitCustomerAllocation} type={props.type} />
          </Tab>}
          <Tab title={'Provider Companies'} >
            <AllCompanies setSort={props.setSort} applySort={props.applySort} companyData={props.providerComapnies} approveOrRejectCustomer={props.approveOrRejectCustomer} total={props.providerTotal} handlePageChange={props.handlePageChange} submitSourcedBy={props.submitSourcedBy}  allocatedToList={props.allocatedToList} SubmitCustomerAllocation={props.SubmitCustomerAllocation} type={props.type} blackListCustomer={props.blackListCustomer}/>
          </Tab>
      </TabStrip>
    </section>
  )
}

export default AllCompaniesTab